import { ExternalStorageToolVariant, ExternalStorageVariantFeatures } from "./externalStorage.types";

export const EXTERNAL_STORAGE_VARIANT_CONFIG: Record<
  ExternalStorageToolVariant,
  ExternalStorageVariantFeatures
> = {
  mapping: {
    supportsNotes: true,
    supportsDataType: true,
    supportsStorageEnvironment: true,
    supportsWeightUnit: true,
    supportsNewFacility: true,
    supportsFacilityView: true,
    usesSearchFacility: false,
    lockNameWhenSaved: false,
    deleteTitle: "Delete External Warehouse",
    deleteSubtitle:
      "Are you sure you want to remove the external storage? Please consider you cannot recover these data after remove"
  },
  simulate: {
    supportsNotes: false,
    supportsDataType: true,
    supportsStorageEnvironment: true,
    supportsWeightUnit: true,
    supportsNewFacility: false,
    supportsFacilityView: true,
    usesSearchFacility: true,
    lockNameWhenSaved: true,
    deleteTitle: "Delete External Warehouse",
    deleteSubtitle:
      "Are you sure you want to remove the external storage? Please consider you cannot recover these data after remove"
  },
  supplier: {
    supportsNotes: false,
    supportsDataType: false,
    supportsStorageEnvironment: false,
    supportsWeightUnit: false,
    supportsNewFacility: false,
    supportsFacilityView: false,
    usesSearchFacility: false,
    lockNameWhenSaved: false,
    deleteTitle: "Delete External Warehouse",
    deleteSubtitle:
      "Are you sure you want to remove the external storage? Please consider you cannot recover these data after remove"
  }
};

export const getExternalStorageVariantConfig = (
  variant: ExternalStorageToolVariant
): ExternalStorageVariantFeatures => EXTERNAL_STORAGE_VARIANT_CONFIG[variant];
